const $inject = ['$state', 'lbDialogService'];

const locationService = function ($state, lbDialogService) {
  const searchDefaults = {
    Hotel: 0,
    Car: 0,
    Rail: 0,
    Flight: 0
  };

  let service = {
    currentSearchType: undefined,
    searchIndex: searchDefaults,
    reset: reset,
    updateCurrentSearchType: updateCurrentSearchType,
    increaseSearchIndex: increaseSearchIndex,
    nextPage: nextPage,
    gotoSection: gotoSection,
    cancelBooking: cancelBooking
  };

  const sessionSearchIndex = JSON.parse(sessionStorage.getItem('locationService:searchIndex'));

  if (sessionSearchIndex) {
    service.searchIndex = sessionSearchIndex;
  }

  function reset() {
    service.currentSearchType = undefined;
    service.searchIndex = searchDefaults;

    sessionStorage.removeItem('locationService:currentSearchType');
    sessionStorage.removeItem('locationService:searchIndex');
  }

  function updateCurrentSearchType(type) {
    service.currentSearchType = type;
    sessionStorage.setItem('locationService:currentSearchType', service.currentSearchType);
  }

  function increaseSearchIndex(type, increment) {
    increment = increment || 1;

    let newIndex = service.searchIndex[type] + increment;

    setSearchIndex(type, newIndex);
  }

  function setSearchIndex(type, value) {
    service.searchIndex[type] = value;
    sessionStorage.setItem('locationService:searchIndex', JSON.stringify(service.searchIndex));
  }

  function nextPage(search, isItineraryChanging) {
    const searchTypes = search.SearchTypes;
    let type = service.currentSearchType;
    let nextType = type;

    if (type) {
      const searchTypeCompleted = search[`${type}s`].length === service.searchIndex[type];

      if(searchTypeCompleted) {
        setSearchIndex(type, 0);

        let searchTypeIndex = searchTypes.indexOf(type);
        let nextSearchTypeIndex = searchTypeIndex + 1;

        if(nextSearchTypeIndex < searchTypes.length) {
          nextType = searchTypes[nextSearchTypeIndex];
        } else {
          nextType = 'Confirm';
        }
      }
    } else {
      nextType = searchTypes[0];
    }

    gotoSection(nextType, isItineraryChanging);
  }

  function gotoSection(section, isChanging) {
    const stateParent = isChanging ? 'app.booking.change' : 'app.booking';

    switch (section) {
      case 'Flight':
        $state.go(`${stateParent}.flights`, {}, { reload: true });

        break;
      case 'Rail':
        $state.go(`${stateParent}.rail`, {}, { reload: true });

        break;
      case 'Hotel':
        $state.go(`${stateParent}.hotels`, {}, { reload: true });

        break;
      case 'Car':
        $state.go(`${stateParent}.cars`, {}, { reload: true });

        break;
      case 'Confirm':
        const msie = document.documentMode;

        if (msie === 9) {
          window.location.hash = isChanging ? '/manage-bookings/change/payment' : '/itinerary';
          location.reload(true);
        } else {
          const stateName = isChanging ? 'app.change.payment' : 'app.itinerary';
          $state.go(stateName, {}, { reload: true });
        }

      break;
      default:
        console.warn('NO NEXTPAGE FOUND!');
    }
  }

  function cancelBooking() {
    let dialogOptions = {
      title: 'This will cancel the current search',
      message: 'Are you sure you want to do this?',
      warningLevel: 'warning',
      submitButtonText: 'OK'
    };

    return lbDialogService.show(dialogOptions);
  }

  return service;
};

locationService.$inject = $inject;

export default locationService;



// WEBPACK FOOTER //
// ./src/services/locationService.js